import { unstable_serialize } from 'swr'

// This base key is used to search on all swr keys
export const composeBaseSwrKey = ({ method, key }) => {
	return [key ?? method?.key]
}

export const composeSwrKey = ({ client, method, key, args = {} }) => {
	return [
		...composeBaseSwrKey({ method, key }),
		args,
		client.defaults.headers.store,
		client.defaults.headers.currency,
		client.defaults.headers.userGroup,
		client.defaults.headers.salesAgentGroup,
	]
}

export const serializeSwrKey = (key) => unstable_serialize(key)

export const composeAndSerializeSwrKey = (...args) => serializeSwrKey(composeSwrKey(...args))
